module.exports = __webpack_public_path__ + "static/media/c11-wifi.ca5292b2.png";